/* eslint-disable react/no-danger */
// import styles from './button.module.scss'
import { Button, type ButtonProps } from './button'
import styles from './button.module.scss'

interface ButtonWithDisclaimerProps extends ButtonProps {
  disclaimer?: string
}

const ButtonWithDisclaimer = ({ disclaimer, ...buttonProps }: ButtonWithDisclaimerProps) => (
  <div className={styles.buttonWithDisclaimerContainer}>
    <Button {...buttonProps} />
    {disclaimer ? <div className={styles.buttonDisclaimer}>{disclaimer}</div> : null}
  </div>
)

export default ButtonWithDisclaimer
